/**
 * @file 导航域 - 桥接行为封装
 * @description 封装与"改变当前位置/页面"相关的桥接行为：
 *   - 返回上一页（App 原生 / H5 window.close）
 *   - 后续同类方法：地图导航、打开页面等
 * @rule 新增导航类 handler 直接在此文件追加，不得新建文件
 */

import { bridge } from '../methods'
import { BRIDGE_METHODS } from '../constants'

/**
 * 检测是否在 APP 中
 */
function isInApp(): boolean {
  return typeof window !== 'undefined' && !!window.flutter_inappwebview
}

/**
 * 关闭当前页面
 * @description App 环境调用原生关闭，H5 环境关闭当前窗口
 */
export function closePage(): void {
  if (isInApp()) {
    bridge.invoke(BRIDGE_METHODS.GO_BACK)
    return
  }
  window.close()
}
